<template>
  <div class="uploadDalog">
    <ul>
      <li v-for="(item, index) in JSON.parse(uploadData.TYPE)" :key="index">
        <a :href="item.url">{{ item.name }}</a>
        <!-- <Icon @click="clear" style="marginLeft:3px" type="ios-close-circle-outline" /> -->
      </li>
      <Upload
        multiple
        action="/p/cs/batchUpload"
        name="files"
        :data="uplData"
        :on-success="onSuccess"
        :on-error="onError"
        v-if="false"
      >
        <span class="uplFile"> <Icon type="md-cloud-upload" />上传附件 </span>
      </Upload>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    uplData() {
      let obj = {}
      obj['path'] = `${this.$route.params.tableName}/${
        this.$route.params.itemId
      }/${new Date().getTime()}/`
      return obj
    },
  },
  props: {
    uploadData: {
      type: Object,
      defulat: {},
    },
  },
  methods: {
    onSuccess(res, file, filelist) {
      if (res.code == 0) {
        let data = ''
        let formdata = new FormData()
        data = filelist.map((res) => {
          return res.response.data[0].UploadId
        })
        formdata.append('uploadIds', data.join(','))
        axios({
          url: '/p/cs/batchUploadProgress',
          method: 'post',
          data: formdata,
        }).then((res) => {
          console.log(res)
          if (res.data.code == 0) {
            this.save(filelist)
          }
        })
      } else {
        this.$Message.warning(res.message)
      }
    },
    onError(e) {
      console.log(e)
    },
    save(val) {
      let newData = {}
      newData['name'] = val[0].response.data[0].Name
      newData['Size'] = val[0].response.data[0].Size
      newData['url'] = val[0].response.data[0].Url
      let obj = {}
      obj['table'] = this.$route.params.tableName
      obj['objid'] = this.$route.params.itemId
      let arr = []
      arr[0] = {}
      arr[0]['ID'] = this.uploadData.ID
      //   arr[0]['TYPE'] = this.
      let before = {}
      let beforeArr = []
      beforeArr[0] = {}
      beforeArr[0]['ID'] = this.uploadData.ID
      beforeArr[0]['TYPE'] = this.uploadData.TYPE
      before['CL_C_VI_DESIGN_COMMIT'] = beforeArr

      let TYPE = JSON.parse(this.uploadData.TYPE)
      TYPE.push(newData)
      arr[0]['TYPE'] = JSON.stringify(TYPE)
      obj['data'] = {}
      obj['after'] = {}
      obj['data']['CL_C_VI_DESIGN_COMMIT'] = arr
      obj['after']['CL_C_VI_DESIGN_COMMIT'] = arr
      obj['before'] = before
      //以上为组合请求参数
      R3.network
        .post('/p/cs/objectSave', R3.urlSearchParams(obj))
        .then((res) => {
          console.log(res)
          if (res.data.code == 0) {
            this.$Message.success(res.data.message)
            this.$emit('refresh')
          } else {
            this.$Message.error(res.data.message)
            this.$emit('refresh')
          }
        })
    },
  },
}
</script>

<style scoped lang="less">
ul li {
  list-style: none;
}
.uploadDalog {
  ul {
    li,
    .uplFile {
      cursor: pointer;
      color: #0f8ee9;
      margin: 6px;
    }
  }
}
</style>
